import { render, staticRenderFns } from "./handover.vue?vue&type=template&id=3818ab90&scoped=true"
import script from "./handover.vue?vue&type=script&lang=js"
export * from "./handover.vue?vue&type=script&lang=js"
import style0 from "./handover.vue?vue&type=style&index=0&id=3818ab90&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3818ab90",
  null
  
)

export default component.exports